export default "__VITE_ASSET__DY2hdpVr__"